import React from "react";
import { InputRangeRow } from "./index";
// Used by Hacoba NSA-HS machine

export default function ThreadBreakTimeoutRow() {
   return (
      <InputRangeRow
         titleProp={"Thread Break Timeout"}
         descriptionProp={"sec"}
         sizeProp={4}
         typeProp={"text"}
         minProp={0}
         maxProp={10}
         propertyNameProp={"threadBreakTimeout"}
         errorDialogueProp={"0.00-10.00 only"}
         floatProp={true}
      />
   );
}
